const pt = {
  100000001:'Informação chave',
  100000002:'Moeda Token',
  100000003:'Criador de cópias',
  100000004:'Tempo de Criação da Instância',
  100000005:'Informações básicas',
  100000006:'Chain/protocolo associado',
  100000007:'Endereço do contrato',
  100000008:'Data da Emissão',
  100000009:'Oferta Total',
  100000010:'Oferta Circulante',
  100000011:'Valor de Mercado',
  100000012:'Informações',
  100000013:'Informações de redes sociais',
  100000014:'Site',
  100000015:'Livro Branco',
  100000016:'Explorador de blockchain',
  100000017:'Pontuação do Projeto',
  100000018:'Classificação',
  100000019:'Top',
  100000020:'Code security',
  100000021:'Operation Performance',
  100000022:'Market Stability',
  100000023:'Governance Strength',
  100000024:'Project Health',
  100000025:'Community Trust',
  100000026:'Tempo Atualizado',
  100000027:'Pontuação de segurança',
  100000028:'Pontuação de segurança do contrato',
  100000029:'Estatísticas de projetos de risco',
  100000030:'Detalhes do código do contrato',
  100000031:'Imposto de Compra',
  100000032:'Imposto de Venda',
  100000033:'É Armadilha?',
  100000034:'É possivelmente mintável.',
  100000035:'Tem Lista Negra',
  100000036:'Tem lista branca?',
  100000037:'Anti-baleia',
  100000038:'Pode alterar a taxa de imposto',
  100000039:'Não é código aberto',
  100000040:'Possui Proprietário Oculto',
  100000041:'Pode auto-destruir',
  100000042:'É um contrato de proxy?',
  100000043:'Pode alterar o saldo',
  100000044:'Possui Chamadas Externas',
  100000045:'Pode Recuperar a Propriedade',
  100000046:'Existe Período de Espera para Transferências',
  100000047:'Transferência pode ser pausada?',
  100000048:'Propriedade Não Renunciada',
  100000049:'É Modificável Anti-Baleia',
  100000050:'Decimal muito pequeno',
  100000051:'Métodos Públicos de Mintar e Queimar',
  100000052:'A queima deve atualizar a oferta total',
  100000053:'Queimar deve atualizar a permissão',
  100000054:'Transferência interna pode dobrar o saldo',
  100000055:'Transferir mais que o saldo deve falhar',
  100000056:'Saldo não atualizado durante a transferência',
  100000057:'Transferência Não Deve Usar Saldo do Gastador',
  100000058:'Transferência acima da autorização excede saldo disponível',
  100000059:'O método BurnFrom deve atualizar o suprimento total.',
  100000060:'Detecte o imposto de compra do token. Acima de 5% é considerado uma alta taxa.',
  100000061:'Detecte o imposto sobre a venda do token. Acima de 5% é considerado alta taxa.',
  100000062:'Verifique se o token é uma fraude honeypot',
  100000063:'Verifique se mais tokens podem ser criados.',
  100000064:'Verifique se o token possui uma lista negra que pode restringir os usuários de trocar ou transferir tokens.',
  100000065:'Verifique se o token possui uma lista de permissões que permite endereços ignorarem restrições.',
  100000066:'Verifique se o token possui mecanismos anti-baleia.',
  100000067:'Verifique se o token tem um imposto e se ele pode ser modificado por funções privilegiadas.',
  100000068:'Verifique se o token foi verificado no explorador de blockchain.',
  100000069:'Verifique se o token tem um proprietário oculto que pode manipular o contrato, mesmo que a propriedade pareça ter sido renunciada.',
  100000070:'Verifique se o token pode se autodestruir.',
  100000071:'Verifique se o token é um contrato proxy que delega chamadas de função a um contrato de implementação.',
  100000072:'Verifique se o saldo do token pode ser modificado por roles privilegiadas.',
  100000073:'Verifique se o token chama contratos externos',
  100000074:'Verifique se o token tem uma porta dos fundos para recuperar a propriedade.',
  100000075:'Verifique se o token possui um mecanismo de resfriamento de transferência.',
  100000076:'Verifique se o comércio do token pode ser pausado por papéis privilegiados.',
  100000077:'Verifique se o privilégio do proprietário foi renunciado.',
  100000078:'Verifique se os mecanismos anti-baleia do token podem ser modificados por papéis privilegiados.',
  100000079:'Verifique se o valor de retorno da função `decimals()` é maior ou igual a 5.',
  100000080:'Verifique se a chamada das funções `mint()` e `burn()` por usuários aleatórios causará revert.',
  100000081:'Verifique se chamar a função `burn()` atualizará corretamente o `totalSupply`.',
  100000082:"Verifique se chamar a função `burnFrom()` atualizará a concessão corretamente.",
  100000083:'Verifique se chamar a função `transfer()` com o destinatário igual ao remetente da transação aumentará o saldo do remetente.',
  100000084:'Verifique se a chamada da função `transfer()` com um valor maior que o saldo falhará.',
  100000085:"Verifique se a autorização do gastador foi atualizada adequadamente após chamar a função `transferFrom()`.",
  100000086:"Verifique se chamar a função `transferFrom()` usará o saldo do gastador.",
  100000087:"Verifique se a aprovação é atualizada corretamente após chamar `transferFrom()`, ou se a transação falha se o valor for inválido.",
  100000088:"Verifique se chamar a função `burnFrom()` atualizará corretamente o `totalSupply`.",
  100000089:'Verifique se a autoridade de emissão existe',
  100000090:'Verificar se a autoridade de congelamento existe',
  100000091:'Verifica se os metadados podem ser alterados',
  100000092:'Crítico',
  100000093:'Sério',
  100000094:'Médio',
  100000095:'Leve',
  100000096:'Informação',
  100000097:'Autoridade de mint foi revogada',
  100000098:'A autoridade de congelamento foi revogada',
  100000099:'É possível alterar os metadados.',
  100000100:'',
  100000101:'',
  100000102:'',
  100000103:'',
  100000104:'',
  100000105:'',
}
export default pt


// WEBPACK FOOTER //
// ./src/i18n/langs/languageAllen/pt.js